import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import StoreMallDirectoryIcon from '@material-ui/icons/StoreMallDirectory';
import UserAvatar from './UserAvatar';
import { useHistory } from 'react-router-dom';
import CallUser from './CallUser';
import DriverInterests from '../Dialog/DriverInterests/DriverInterests';
import SelectAddress from '../Dialog/SelectAddress/SelectAddress';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { store as mainStore } from '../../store';
import axios from '../../api/axios';
import { isMobile } from 'react-device-detect';
import useRules from '../../hooks/useRules';
import SpeakerNotesOffIcon from '@material-ui/icons/SpeakerNotesOff';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import ProgressiveButton from '../../components/Button/ProgressiveButton';
import { useSearchParams } from 'hooks/useSearchParams';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import { ChangePhoneNumberModal } from './ChangePhoneNumberModal';
import { checkMobilePhone } from 'fns';
import { useFreight } from 'useStores/useFreight';

const useStyles = makeStyles((theme) => ({
  briefContainer: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '6fr 1fr',
    gridGap: theme.spacing(1),
  },
  details: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr',
    gridGap: theme.spacing(1),
    '&> div': {
      color: '#000',
      display: 'flex',
      flexFlow: 'row nowrap',
      '& > span': {
        marginRight: theme.spacing(1),
      },
    },
    '& > div >span:first-child': {},
    '& > div > span': {
      color: '#ccc',
      marginRight: theme.spacing(0.5),
    },
  },
  actions: {
    textAlign: 'right',
    display: 'flex',
    flexDirection: 'column',
    '& > button': {
      marginBottom: theme.spacing(1),
    },
  },
  newOrderBtn: {
    background: '#673ab7',
    color: '#fff',
    '&:hover': {
      background: '#7e57c2',
    },
  },
}));

const BriefInfo = ({ user, showActions = true, driverId, refetchUserData }) => {
  const classes = useStyles();
  const [rules, hasRule, isAdmin] = useRules();
  const history = useHistory();
  const { showError, showMessage } = useContext(mainStore);
  const [params, setParams, deleteParams] = useSearchParams();
  const [driverInterestsD, setDriverInterestsD] = useState(
    params.get('modal') || false
  );
  const [addressToggle, setAddressToggle] = useState(false);
  const [progress, setProgress] = useState(false);
  const [openChangePhoneModal, setOpenChangePhoneModal] = useState(false);
  const [isLoadingMobile, setIsLoadingMobile] = useState(false);
  const setChoosedFreight = useFreight((state) => state.setChoosedFreight);
  const choosedFreight = useFreight((state) => state.choosedFreight);
  let role = user?.role?.[0];

  const handleShowDriverIntrestsD = () => {
    setParams([{ name: 'modal', value: true }]);
    setDriverInterestsD(true);
  };
  const handleCloseDriverIntrestsD = () => {
    deleteParams([{ name: 'modal' }]);
    setDriverInterestsD(false);
  };
  const handleToggleAddress = () => {
    setAddressToggle(!addressToggle);
  };
  const handleOpenInPWA = async (userId) => {
    try {
      const { data } = await axios.post(`/api/v1/admin/users/accessToPWA`, {
        userId,
      });
      if (data?.ok) {
        showMessage(data?.messages || 'شما در حال انتقال هستید ...');
        window.open(data.url);
      }
    } catch (error) {
      showError(error);
    }
  };
  const handleToggleBlacklist = async (userId) => {
    try {
      setProgress(true);
      const { data } = await axios.post(`/api/v1/admin/users/blacklist`, {
        userId,
      });
      if (data?.ok) {
        showMessage(data?.messages);
        window.location.reload();
      }
    } catch (error) {
      showError(error);
    }
    setProgress(false);
  };

  const submitPhoneNumber = async (mobilePhone) => {
    try {
      setIsLoadingMobile(true);
      const { data } = await axios.put(
        `/api/v1/admin/user/${user?._id}/changeMobilePhone`,
        {
          mobilePhone: checkMobilePhone(mobilePhone),
        }
      );
      showMessage(data.messages[0]);
      setOpenChangePhoneModal(false);
      window.location.reload();
    } catch (error) {
      console.error(error);
      showError(error);
    } finally {
      setIsLoadingMobile(false);
    }
  };

  function handleOpenChangePhoneModal() {
    setOpenChangePhoneModal(true);
  }

  const handleCloseChangePhoneModal = (agree, phoneNumber) => {
    if (agree) {
      return submitPhoneNumber(phoneNumber);
    } else {
      return setOpenChangePhoneModal(false);
    }
  };

  return (
    <div className={classes.briefContainer}>
      {openChangePhoneModal && (
        <ChangePhoneNumberModal
          loading={isLoadingMobile}
          handleClose={(agree, phoneNumber) =>
            handleCloseChangePhoneModal(agree, phoneNumber)
          }
          open={openChangePhoneModal}
        />
      )}
      {addressToggle ? (
        <SelectAddress
          onSave={handleToggleAddress}
          onClose={handleToggleAddress}
          _customer={user}
        />
      ) : null}
      {role === 'driver' ? (
        <DriverInterests
          open={driverInterestsD}
          onClose={handleCloseDriverIntrestsD}
          driverId={driverId}
          user={user}
          refetchUserData={refetchUserData}
        />
      ) : null}

      <div className={classes.details}>
        {user?.legal ? (
          <div>
            <span>نام شرکت:</span>
            <Link to={`/protected/admin/users/customer/${user?._id}`}>
              {user?.company}
            </Link>
          </div>
        ) : null}
        {user?.legal ? (
          <div>
            <span>شناسه ملی شرکت:</span>
            {user?.companyNationalCode}
          </div>
        ) : null}
        {user?.legal ? (
          <div>
            <span>شماره تلفن شرکت:</span>
            <CallUser tel={user?.phone} />
          </div>
        ) : null}
        {user?.legal ? (
          <div>
            <span>آدرس:</span>
            {user?.address}
          </div>
        ) : null}
        <div>
          <span>{user?.legal ? `نام نماینده شرکت:` : `نام:`}</span>
          <Link to={`/protected/admin/users/customer/${user?._id}`}>
            {user?.firstName}
          </Link>
        </div>
        <div>
          <span>
            {user?.legal ? `نام خانوادگی نماینده شرکت:` : `نام خانوادگی:`}
          </span>
          <Link to={`/protected/admin/users/customer/${user?._id}`}>
            {user?.lastName}
          </Link>
        </div>
        <div>
          <span>کدملی:</span>
          {user?.nationalCode}
        </div>
        <div>
          <span>موبایل:</span>
          <CallUser tel={user?.mobilePhone} />
        </div>
      </div>
      {showActions ? (
        <div className={classes.actions}>
          {role === 'customer' ? (
            <Button
              variant="contained"
              size="medium"
              endIcon={<AddCircleIcon />}
              onClick={() =>
                history.push(`/protected/admin/orders/add`, {
                  order: { customer: user },
                })
              }
              className={classes.newOrderBtn}
              color="inherit"
            >
              سفارش‌جدید
            </Button>
          ) : null}
          {role === 'freight' && !choosedFreight ? (
            <Button
              variant="contained"
              size="medium"
              endIcon={<AddCircleIcon />}
              onClick={() => {
                setChoosedFreight(user);
                history.push(`/protected/admin/freights/newOrder`, {
                  order: { customer: user },
                });
              }}
              className={classes.newOrderBtn}
              color="inherit"
            >
              سفارش‌جدید
            </Button>
          ) : null}
          {role === 'customer' ? (
            <Button
              variant="text"
              size="medium"
              endIcon={<StoreMallDirectoryIcon />}
              // onClick={null}
              color="secondary"
              onClick={handleToggleAddress}
            >
              مدیریت‌انبارها
            </Button>
          ) : null}
          {role === 'driver' ? (
            <Button
              variant="contained"
              size="medium"
              endIcon={<AddCircleIcon />}
              onClick={handleShowDriverIntrestsD}
              className={classes.newOrderBtn}
              color="inherit"
            >
              ثبت علایق‌راننده
            </Button>
          ) : null}
          <Button
            variant="text"
            size="medium"
            color="secondary"
            endIcon={<EditIcon />}
            onClick={() =>
              history.push(`/protected/admin/users/edit/${role}/${user?._id}`, {
                values: user,
              })
            }
          >
            {role === 'customer'
              ? 'ویرایش کاربر'
              : role === 'driver'
              ? 'ویرایش راننده'
              : 'ویرایش'}
          </Button>
          {hasRule('can_blacklist_user') && (
            <ProgressiveButton
              variant="text"
              size="medium"
              color="secondary"
              endIcon={
                user?.blacklist ? <SpeakerNotesIcon /> : <SpeakerNotesOffIcon />
              }
              onClick={() => handleToggleBlacklist(user?._id)}
              // style={{background:"#000"}}
              disabled={progress}
            >
              {user?.blacklist ? 'فعالسازی پیامک' : 'عدم ارسال پیامک'}
            </ProgressiveButton>
          )}
          {hasRule('can_see_pwa_button') && (
            <Button
              variant="text"
              size="medium"
              color="secondary"
              endIcon={<OpenInNewIcon />}
              onClick={() => handleOpenInPWA(user?._id)}
            >
              PWA
            </Button>
          )}
          <Button
            variant="text"
            size="small"
            color="secondary"
            endIcon={<PhoneIphoneIcon />}
            onClick={handleOpenChangePhoneModal}
          >
            تغییر شماره موبایل
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default BriefInfo;
